import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import {
  DangerButton,
  SecondaryDangerButton,
} from "../../../../components/customComponent";
import { useDispatch } from "react-redux";
import { editEquipment } from "../../../store/actions/bplrt/equipmentAction";
import { useTranslation } from "react-i18next";
import { parseVariables } from "../../../../helpers/localize";
import parser from "html-react-parser";

const RemoveSingleBreakdown = ({ equipment }) => {
  const dispatch = useDispatch();

  const { t } = useTranslation("bplrtEquipment");

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };

  const handleRemove = () => {
    const payload = { equipments: [{ id: equipment.id, isDisrupted: false }] };

    dispatch(editEquipment(payload));
    handleClickClose();
  };

  return (
    <>
      <IconButton onClick={handleClickOpen} color="error" variant="contained">
        <DeleteIcon fontSize="small" />
      </IconButton>

      <Dialog maxWidth="sm" open={open} onClose={handleClickClose}>
        <DialogContent>
          <DialogContentText
            sx={{
              textAlign: "center",
              mb: 2,
            }}
          >
            {parser(
              parseVariables(t("removeSingleBreakdownConfirmHint"), {
                item:
                  equipment.station.code +
                  " (" +
                  equipment.station.name +
                  ") - " +
                  equipment.name,
              })
            )}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <SecondaryDangerButton
            fullWidth
            startIcon={<ClearIcon />}
            onClick={handleClickClose}
          >
            {t("cancelBtn")}
          </SecondaryDangerButton>

          <DangerButton
            fullWidth
            startIcon={<DoneIcon />}
            onClick={handleRemove}
          >
            {t("removeSingleBreakdownSubmitBtn")}
          </DangerButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RemoveSingleBreakdown;
